<template>
    <div class="site-status">
        <div v-if="getSiteUiStatus" class="website-label" :class="getSiteUiStatus">
            <img :src="'/images/status_' + getSiteUiStatus + '.svg'" :alt="getSiteUiStatus">
            <span>{{ getSiteUiStatus }}</span>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        site: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        /**
         * @returns {string} UI representation of website status
         */
        getSiteUiStatus() {
            switch (this.site.status) {
            case 'dev':
                return 'staging';
            case 'active':
                return 'live';
            case 'inactive':
                return 'inactive';
            case 'excessive':
                return 'excessive';
            default:
                return false;
            }
        },
    },
};

</script>
